
import Schema from 'AppReact/schema';

export default {
  showCheckboxes: Schema('boolean', 'primitive-nullable', { defaultValue: null })
}

